import React from 'react';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderNothing, withProps } from 'recompose';
import { ConfigService } from '../../../services/config-service';
import { THeadline } from '../../../components/template';
import { getNextActivity } from '../../../store/reducers/digital-coach';
import { withTitleMapper } from '../../dashboard/components/with-title-mapper';

const Component = React.memo(({ title, subtitle }) => <THeadline title={title} subtitle={subtitle} />);

const CoachieTitle = compose(
  connect(null, { getNextActivity }),
  withProps(() => ConfigService.get('COACH', {})),
  withTitleMapper,
  lifecycle({
    async componentDidMount() {
      const { display, getNextActivity } = this.props;

      if (display === 'manual') {
        await getNextActivity();
      }
    }
  }),
  branch(({ title }) => !title, renderNothing)
)(Component);

export const withCoachieTitle = Component => props =>
  (
    <>
      <CoachieTitle display={props.display} />
      <Component {...props} />
    </>
  );
